import React from "react"
import Modal from "react-modal"

import "./style.css"
import Loader from "../../common/Loader"
import { OrangeButton } from "../../common"

const LoadingInfoModal = ({
  show,
  title,
  text,
  onModalCloseClick,
  dirRtl,
  onOopsClicked,
  oopsButtonText,
  isBoxit,
  showBoxitOpened,
  showBoxitClosed,
  onBoxitIsOpened,
  onBoxitIsClosed,
  onBoxitDoorIsNotOpened,
  textContinueAfterDoorOpened,
  textContinueAfterDoorClosed,
  textCellNotOpened,
}) => {
  if (!show) {
    return <></>
  }

  const wrapperClassName = `${dirRtl ? "dirrtl" : "dirltr"}`
  const renderOopsButton = (onOopsClicked) => {
    if (!onOopsClicked) {
      return
    }

    return (
      <OrangeButton onClick={(e) => onOopsClicked()} extraClass="wfll-oops-btn">
        {oopsButtonText}
      </OrangeButton>
    )
  }

  const renderBoxitIsOpenedClosedDoorContinueButtons = (
    isBoxit,
    showBoxitOpened,
    showBoxitClosed,
    onBoxitIsOpened,
    onBoxitIsClosed,
    onBoxitDoorIsNotOpened,
    textContinueAfterDoorOpened,
    textContinueAfterDoorClosed,
    textCellNotOpened
  ) => {
    if (!isBoxit) {
      return
    }

    if (showBoxitOpened) {
      return (
        <div className="is-boxit-door-buttons">
          <OrangeButton onClick={(e) => onBoxitIsOpened()}>
            {textContinueAfterDoorOpened}
          </OrangeButton>
          <OrangeButton onClick={(e) => onBoxitDoorIsNotOpened()}>
            {textCellNotOpened}
          </OrangeButton>
        </div>
      )
    }

    if (showBoxitClosed) {
      return (
        <div className="is-boxit-door-buttons">
          <OrangeButton onClick={(e) => onBoxitIsClosed()}>
            {textContinueAfterDoorClosed}
          </OrangeButton>
        </div>
      )
    }
  }

  return (
    <Modal
      isOpen={show}
      onRequestClose={onModalCloseClick}
      className={`react-modal-content ${wrapperClassName}`}
      overlayClassName="modal-overlay"
    >
      <div
        className="loadinfmodal-label-extra-class"
        dir={dirRtl ? "rtl" : "ltr"}
      >
        {title}
      </div>
      <div
        className="loadinfmodal-label-extra-class loadinfmodal-label-extra-class2"
        dir={dirRtl ? "rtl" : "ltr"}
      >
        {text}
      </div>
      <Loader />
      {renderOopsButton(onOopsClicked)}
      {renderBoxitIsOpenedClosedDoorContinueButtons(
        isBoxit,
        showBoxitOpened,
        showBoxitClosed,
        onBoxitIsOpened,
        onBoxitIsClosed,
        onBoxitDoorIsNotOpened,
        textContinueAfterDoorOpened,
        textContinueAfterDoorClosed,
        textCellNotOpened
      )}
    </Modal>
  )
}

export default LoadingInfoModal
